import React from 'react';
import { Users } from 'lucide-react';
import AdminCRUD from '../../components/admin/AdminCRUD';

const STATUS = { active:'bg-emerald-100 text-emerald-700', approved:'bg-blue-100 text-blue-700', rejected:'bg-red-100 text-red-700', pending:'bg-amber-100 text-amber-700' };

export default function AdminVolunteers() {
  return (
    <AdminCRUD
      endpoint="volunteers"
      title="Volunteers"
      icon={Users}
      columns={[
        { key:'fullName', label:'Name', render:(v,item) => (
          <div>
            <div className="font-semibold text-gray-900">{v || item.name || '—'}</div>
            <div className="text-xs text-gray-400">{item.email}</div>
          </div>
        )},
        { key:'phone', label:'Phone', render: v => <span className="text-sm text-gray-600">{v || '—'}</span> },
        { key:'location', label:'Location', render: v => v || '—' },
        { key:'availability', label:'Availability', render: v => Array.isArray(v) ? v.join(', ') : (v || '—') },
        { key:'status', label:'Status', render: v => <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold capitalize ${STATUS[v] || 'bg-gray-100 text-gray-600'}`}>{v}</span> },
        { key:'createdAt', label:'Applied', render: v => <span className="text-xs text-gray-400">{new Date(v).toLocaleDateString('en-NG')}</span> },
      ]}
      defaultForm={{ fullName:'', email:'', phone:'', location:'', occupation:'', preferredProgram:'', availability:'flexible', motivation:'', status:'pending' }}
      formFields={[
        { key:'fullName', label:'Full Name', required:true },
        { key:'email', label:'Email', type:'email', required:true },
        { key:'phone', label:'Phone', required:true },
        { key:'location', label:'Location / State' },
        { key:'occupation', label:'Occupation' },
        { key:'preferredProgram', label:'Preferred Program' },
        { key:'availability', label:'Availability', type:'select', options:['weekdays','weekends','both','flexible','remote'] },
        { key:'status', label:'Status', type:'select', options:['pending','approved','rejected','active'] },
        { key:'motivation', label:'Motivation / Message', type:'textarea', fullWidth:true },
        { key:'notes', label:'Admin Notes', type:'textarea', fullWidth:true },
      ]}
    />
  );
}
